module.exports = __webpack_public_path__ + "img/icon-letter-d.08f7084f.svg";